import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfirmButton } from '../commons';
import { NationalAccountContext } from '../../../../../contexts';
import { mainPageBlurb } from '../../../../../constants/NationalAccount';
import { setOverlayEvent } from '../../../../../utils/analytics';

export const NotEnrolledSummary = (): JSX.Element => {
  const { setShowModal, setValidResponseState, isMobile } = useContext(
    NationalAccountContext,
  );
  const sectionClasses = classNames(
    'sui-flex sui-flex-col sui-justify-between',
    {
      'sui-align-center': isMobile,
      'sui-align-start': !isMobile,
    },
  );
  return (
    <div className={sectionClasses}>
      <div className="sui-py-6 md:sui-w-5/6 sui-text-base lg:sui-text-lg">
        <p>{mainPageBlurb}</p>
      </div>
      <div>
        <ConfirmButton
          confirmBlurb="Learn More"
          disabled={false}
          cb={() => {
            setShowModal(true);
            setOverlayEvent('pricing benefits national account incentives');
            setValidResponseState((prevState: any) => {
              return { ...prevState, enrollState: true };
            });
          }}
        />
      </div>
    </div>
  );
};
